<template>
    <div id="container">
      <div class="wrapper">
       <div class="header__logo">
        <div class="container">
          <a href="/" class="header__logo-link">
            <img
              class="header__logo-image"
              style=""
              src="//cdn.shopify.com/s/files/1/0596/1547/7862/files/logo-aozama-blanco.png?width=280&height=132"
              alt="Aozama"
            />
          </a>
        </div>
      </div>
        <div class="checkout-content container">
            <div class="title-wrap">
                <h2>Procesar Pedido</h2>
            </div>

            <div class="product-wrap">
                <!-- Product Description -->
                <div class="description-table">
                    <h2>{{offer.title}} <span v-show="form.count>1">(x{{form.count}})<span></h2>
                    <div class="table-row value-row">
                        <div class="row-left-wrap">Valor:</div>
                        <div class="row-right-wrap">
                            <span class="currency-symbol">RD</span>
                            <span class="value-amount">{{amount | currency}}</span>
                        </div>
                    </div>
                    <div class="table-row quota-row">
                        <div class="row-left-wrap">ITBIS:</div>
                        <div class="row-right-wrap">
                            RD{{tax | currency}}
                        </div>
                    </div>
                    <div class="table-row quota-row">
                        <div class="row-left-wrap">Valor Total Oferta:</div>
                        <div class="row-right-wrap">
                            RD{{form.offerAmount | currency}}
                        </div>
                    </div>
                    <div class="table-row quota-row" v-show="form.invoice_payment">
                        <div class="row-left-wrap"><b>Pagar Contra Entrega:</b></div>
                        <div class="row-right-wrap" style="color:red;">
                            RD{{form.invoice_payment | currency}}
                        </div>
                    </div>
                    <div class="table-row discount-row">
                        <div class="row-left-wrap">Descuento:</div>
                        <div class="row-right-wrap">
                            {{offer.discount_percent}}%
                        </div>
                    </div>
                    <div class="table-row pay-facility-row">
                        <div class="row-left-wrap">Facilidad de Pago:</div>
                        <div class="row-right-wrap">
                            <div class="quota-selector">
                                <select v-model="form.total_splits" @change="cal()">
                                    <option v-for="day in duesArrays" v-bind:value="day" v-show="day >= min_split">
                                        {{ day }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="table-row quota-row">
                        <div class="row-left-wrap">Cargo por Financiamiento:</div>
                        <div class="row-right-wrap">
                            RD{{financing | currency}}
                        </div>
                    </div>
                    <div class="table-row quota-row">
                        <div class="row-left-wrap">Monto de Cuotas:</div>
                        <div class="row-right-wrap">
                            RD{{form.next_due | currency}}
                        </div>
                    </div>
                    <div class="table-row quota-row">
                        <div class="row-left-wrap">Total a Financiar:</div>
                        <div class="row-right-wrap">
                            RD{{form.total | currency}}
                        </div>
                    </div>
                    <div class="product-details">
                        <div class="details-title">
                            Detalles del producto
                        </div>
                        <div class="product-details-content">
                            {{offer.description}}
                        </div>
                    </div>
                </div>

                <!-- Product Image -->
                <div class="image-wrap">
                    <img src="{{urlApi+offer.image.path}}" alt="">
                    
                    <div style="width:350px;" class="padding-20" v-show="offer.categories_id == 6">
                      <h4 style="line-height:24px;">¿Tienes un dispositivo que quieres intercambiar y usar como abono con Aozama?</h4>
                      
                      <div class="selector-group row form-selector-group">
                        <!-- NO -->
                        <div class="dimension-multiple form-selector">
                          <input class="form-selector-input" name="model" v-model="form.change" id="noTradeIn" type="radio" value="0">
                          <label for="noTradeIn" class="form-selector-label" id="noTradeIn_label">
                            <span class="form-selector-title"> No </span>
                          </label>
                        </div>
                        
                        <!-- SI -->
                        <div class="dimension-multiple form-selector">
                          <input class="form-selector-input" name="model" v-model="form.change" id="tradeIn" type="radio" value="1">
                          <label for="tradeIn" class="form-selector-label" id="tradeIn_label">
                            <span class="form-selector-title"> Sí </span>
                          </label>
                        </div>
                      </div>

                      <!-- Select Model Dropdown -->
                      <div class="form-section-container" v-show="form.change == 1">
                        <div class="form-dropdown-content">
                          <input type="text" class="form-control" v-model="form.device" placeholder="Marca y modelo" />
                        </div>  
                      </div>
                    </div>
                </div>
            </div>

            <div class="buttons-wrap">
                <div class="check-button cancel-btn" @click="goback()">Cancelar</div>
                <div class="check-button accept-btn" @click="sendRequest()">Enviar Solicitud</div>
            </div>
        </div>

      </div>
    </div>
</template>

<script>
export default {
  name: "product-checkout",
  data() {
    return {
      urlApi: "https://api.cashdepotint.com/",
      offer: {
        title: "",
        description: "",
        amount: "",
        images: [],
        image: null,
      },
      creditLimit: {},
      userId: null,
      duesArrays: [],
      form: {
        employee_id: null,
        offer_id: null,
        total_splits: 1,
        interest_amount: null,
        next_due: null,
        subtotal: null,
        total: null,
        invoice_payment: null,
        shop_id: 1,
        itbis: true,
        code: "",
        available_amount: null,
        notCode: true,
        count: 1,
        offerAmount: 1,
        proccess: false,
        change: 0,
        device: "",
      },
      min_split: 1,
      amount: 0,
      tax: 0,
      financing: 0,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.form.offer_id = this.$route.params.id;
    this.form.employee_id = window.localStorage.getItem("employee_id");
    this.chargeForm();
    this.getOffer();
    this.getCreditLimit();
  },
  methods: {
    chargeForm() {
      this.form.next_due = window.localStorage.getItem("next_due");
      this.form.next_due = window.localStorage.getItem("next_due");
      this.form.total_splits = window.localStorage.getItem("total_splits");
      this.form.invoice_payment =
        window.localStorage.getItem("invoice_payment");
      this.form.amount_financed =
        window.localStorage.getItem("amount_financed");
      this.form.count = window.localStorage.getItem("count");
      this.getMinSplit();
    },
    getOffer() {
      this.loadingOffers = true;
      this.$http
        .get(
          apiUrl +
            `/offers/${this.id}?relationships=categories,offersProvider,typeDays,images`
        )
        .then((response) => {
          this.offer = response.data;
          this.offer.image = response.data.images[0];
          var i;
          for (i = 1; i <= response.data.fee; i++) {
            this.duesArrays.push(i);
          }
          this.cal();
          this.form.offerAmount = this.offer.amount * this.form.count;
          this.amount = this.form.offerAmount / 1.18;
          this.tax = this.form.offerAmount - this.form.offerAmount / 1.18;
          this.fixed();
        });
    },
    fixed: function () {
      this.amount = Number(this.amount.toFixed(2));
      this.tax = Number(this.tax.toFixed(2));
    },
    sendRequest: function () {
      var ask = true;
      if (ask) {
        this.form.proccess = false;
        this.$http({
          emulateJSON: true,
          emulateHTTP: true,
          url: apiUrl + "/orders/dues",
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: this.form,
        }).then(
          function (response) {
            sweetAlert(
              "Success",
              "!Solicitud enviada exitosamente! El equipo de CASHDEPOT lo contactará pronto.",
              "success"
            );
            //location.reload();
          },
          (response) => {
            sweetAlert("Oops...", "Ha ocurrido un error !", "error");
          }
        );
      }
    },
    closeAlert: function (ev) {
      if (ev.target.classList.contains("alert-courtine"))
        ev.target.classList.remove("alert-visible");
    },
    cal() {
      if (!this.form.employee_id) {
        return;
      }

      this.offerAmount = this.offer.amount * this.form.count;

      if (this.creditLimit.available_amount > this.offerAmount) {
        this.form.invoice_payment =
          this.offerAmount - this.form.amount_financed;
      } else {
        var canFinance = this.offerAmount - this.creditLimit.available_amount;
        var heFinace = this.offerAmount - this.form.amount_financed;
        if (heFinace > canFinance) {
          this.form.invoice_payment = canFinance;
          //this.form.amount_financed = canFinance;
        } else {
          this.form.invoice_payment = heFinace;
        }
      }

      var amount = this.offerAmount - this.form.invoice_payment;

      var interes = amount * 0.02;
      var total_splits = this.form.total_splits;
      if (total_splits == 0) {
        total_splits = 1;
      }
      this.form.interest_amount = Number((interes * total_splits).toFixed(2));
      this.form.next_due = Number((amount / total_splits + interes).toFixed(2));
      this.form.total = Number((this.form.next_due * total_splits).toFixed(2));
      this.form.subtotal = this.offer.amount;
      this.financing = interes * total_splits;
    },
    getCreditLimit() {
      this.$http
        .get(apiUrl + `/employees/${this.form.employee_id}/limit_credit`)
        .then((response) => {
          this.creditLimit = response.data;
          this.creditLimit.available_amount =
            this.creditLimit.available_amount * 1;
          this.form.available_amount = this.creditLimit.available_amount * 1;
        });
    },
    goback() {
      window.location.replace("/#!/product-detail/" + this.form.offer_id);
    },
    getMinSplit() {
      this.$http
        .get(
          apiUrl +
            `/products/super-market/splits/${this.form.amount_financed}/${this.form.employee_id}`
        )
        .then((response) => {
          this.min_split = response.data.min_split;
          if (this.form.total_splits < this.min_split) {
            this.form.total_splits = this.min_split;
          }
        });
    },
  },
};
</script>

<style scoped>
#checkout-screen {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

#checkout-screen .checkout-content {
  max-width: 1000px;
  width: 100%;
  text-align: left;
  padding-top: 20px;
}

.product-wrap {
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 40px;
  display: flex;
}

.product-wrap .image-wrap {
  padding-left: 40px;
  display: grid;
  grid-auto-rows: max-content;
}

.product-wrap .image-wrap img {
  max-width: 350px;
  height: auto;
}

.description-table {
  font-size: 14px;
  flex: 1;
}

.description-table .table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.title-wrap h2 {
  padding-bottom: 20px;
  margin-bottom: 30px;
  border-bottom: 1px solid #ddd;
  font-weight: 900;
}

.value-row {
  padding-bottom: 5ox !important;
}

.value-row .row-right-wrap {
  color: #213f99;
  display: flex;
  align-items: center;
}

.value-row .row-right-wrap .currency-symbol {
  font-size: 9px;
  padding-top: 2px;
}

.discount-row .row-right-wrap {
  font-weight: 800;
}

.value-row .row-right-wrap .value-amount {
  font-size: 20px;
  font-weight: 800;
  margin-left: 5px;
}

.quota-row .row-right-wrap {
  color: #213f99;
  font-weight: 800;
}

.description-table h2 {
  margin-top: 0;
  margin-bottom: 30px;
  font-weight: lighter;
}

.quota-selector select {
  border: 0;
  font-size: 14px;
}

/* BUTTONS */

.buttons-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
  margin-bottom: 40px;
}

.check-button {
  height: 50px;
  border-radius: 3px;
  background-color: #6c6c6c;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 150px;
  padding: 0 40px;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
  word-break: keep-all;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.accept-btn {
  background-color: #38b449;
  margin-left: 10px;
}

/* PRODUCT DETAILS */

.product-details {
  margin-top: 20px;
}

.details-title {
  color: #00f;
  margin-bottom: 5px;
}

/* ALERT */

.alert-courtine {
  opacity: 0;
  pointer-events: none;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.alert-courtine.alert-visible {
  opacity: 1;
  pointer-events: auto;
}

.alert-content {
  background-color: #fff;
  padding: 50px 35px;
  width: 80%;
  max-width: 390px;
}

.alert-content .alert-checked {
  font-size: 90px;
  color: #38b449;
}

.alert-content h2 {
  margin-bottom: 5px;
}

.alert-content span {
  font-size: 13px;
}

/* MEDIA QUERIES */

@media screen and (max-width: 790px) {
  .product-wrap {
    flex-flow: column wrap;
  }

  .product-wrap .image-wrap {
    padding: 0;
    text-align: center;
    margin-bottom: 20px;
  }
}

@media (max-width: 495px) {
  .check-button {
    padding: 10px;
    min-width: auto;
  }
}

/* Header */
.header__logo {
  background-color: #1e2d7d;
  max-height: 90px;
}

.header__logo a {
  display: block;
}

.header__logo-image {
  width: 180px;
}

.padding--section {
  padding: 25px 0;
}
.border-line {
  border: 1px solid #e7e7e7;
}
/* Button */
.base-button {
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
  word-break: keep-all;
  transition: all 0.3s;
}

.accept-btn {
  background-color: #38b449;
  color: #fff;
}
.accept-btn:hover {
  background-color: #1e2d7d;
}

.home-offer__content {
  padding-bottom: 50px;
}

.home-offer__sliders,
.search-bar-form {
  display: flex;
}

.search-bar-form {
  margin-bottom: 20px;
  margin-top: 40px;
}

.search-bar-form form {
  width: 100%;
}
.search-bar-form__input {
  width: 65%;
  float: left;
}
.search-bar-dropdown {
  width: 23%;
  float: left;
}
.search-bar-form__button {
  width: 10%;
  height: 42px;
  float: right;
}

/* Product Category Slide */
.sliders--title h3 {
  padding-bottom: 15px;
  margin: 20px 0;
  border-bottom: 1px solid #ddd;
}

.splide__list {
  display: flex;
}
.splide__slide {
  margin: 0 10px;
  text-align: center;
}

.splide__slide span {
  font-size: 16px;
  display: inline-block;
  color: #1e2d7d;
}

.splide__slide__container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  font-size: 14px;
}

/* Top Slider */
.top-offers__sliders ul {
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  border-top: 1px solid #f5f5f5;
}

.top-offers__sliders ul li {
  border-left: 1px solid #f5f5f5;
  border-right: 1px solid #f5f5f5;
  margin: 0;
  padding: 15px;
  max-width: 228px;
  width: 100%;
}

/* Offer Style */
.offer--card__slide img {
  max-height: 200px;
}

/* Offer Style Promo */
.offer--card__Promo img {
  max-height: max-content;
}

.offer--title h1 {
  font-weight: bold;
}
.offer--title a {
  display: block;
  margin: 30px 0px 20px;
  text-align: right;
}
.offer--title .col-lg-2,
.offer--title .col-lg-10 {
  padding-left: 0px;
  padding-right: 0px;
}
.offer--cards__bg {
  background: #fff;
  border: 1px solid #ccc;
  padding: 15px 20px;
}
.offer--cards {
  width: 50%;
  min-height: 300px;
  text-align: center;
}
.offer--cards h3 {
  margin-top: 20px;
}
.offer--cards h4 {
  margin-top: 0px;
}
.offer--cards p {
  font-size: 18px;
  margin-top: 30px;
  color: #42494b;
}
.offer--cards a {
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
.sign-price,
.currency-price {
  vertical-align: middle;
  color: #cf3917;
}
.currency-price {
  font-size: 24px;
  color: #cf3917;
  padding: 10px 0;
}
.cent-price {
  vertical-align: sub;
  margin-left: -5px;
  color: #cf3917;
}

/* Providers Slider */
.providers-slide__content {
  width: 210px;
  height: 210px;
  display: flex;
  margin-bottom: 30px;
}
.providers-slide__content img {
  border-radius: 100px;
}

/* Select Form Model */
.form-selector-group {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  list-style: none;
  width: auto;
  margin-top: 8px;
  margin-left: -0.41176rem;
  margin-right: -0.41176rem;
}
.form-selector {
  width: 50%;
  position: relative;
  text-align: center;
  padding: 2%;
  margin-bottom: 15px;
}
.form-selector-input {
  position: absolute;
  opacity: 0;
}
.form-selector-label {
  line-height: 1.23536;
  font-weight: 400;
  letter-spacing: -0.022em;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  min-height: 4.88235rem;
  border: 2px solid #dddddd;
}
.form-selector .form-selector-input:checked ~ .form-selector-label {
  border-color: #1e2d7d;
  border: 2px solid #1e2d7d;
}
.form-selector-title {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// checkout-screen.vue?220d0f28